var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var Svg401 = function Svg401(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E2",
    d: "M19.115 14.26a9.983 9.983 0 0 1-8.558 4.833A9.983 9.983 0 0 1 2 14.259c.997-2.529 4.45-4.394 8.557-4.394s7.56 1.865 8.558 4.394Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEDF0",
    d: "M10.76 11.83c-3.288.31-6.311 1.82-7.315 4.288A10.026 10.026 0 0 1 2 14.26c.997-2.53 4.45-4.395 8.557-4.395h.121c1.248.012 1.325 1.847.082 1.965Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E2",
    d: "M14.886 6.329v1.84a4.329 4.329 0 0 1-8.657 0v-1.84a4.328 4.328 0 1 1 8.657 0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDFEFE",
    d: "M14.54 10.495c.241.081.34.37.195.578-2.03 2.912-6.325 2.913-8.355 0a.381.381 0 0 1 .194-.578l.277-.089c1.69 2.793 5.731 2.78 7.413 0 .093.029.185.058.277.09Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEDF0",
    d: "M10.955 3.697c-1.594.597-2.807 2.114-2.823 4.02 0 .026 0 .051.003.076.033.43 0 .896-.007 1.39-.013 1-1.421 1.204-1.712.248a4.328 4.328 0 0 1-.187-1.262V6.383c0-2.42 2-4.444 4.44-4.383.965.025 1.191 1.358.286 1.696Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACABB1",
    d: "M18.947 12.887c0-.327.356-.514.608-.32l2.226 1.715a.578.578 0 0 1 0 .906l-2.226 1.716c-.252.194-.608.006-.608-.32 0 0 .059-.464-.304-.538-.85-.172-2.389-.261-3.428.838-.203.215-.55.042-.515-.257.143-1.196.858-3.075 3.906-3.356.376-.035.34-.384.34-.384Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEDF0",
    d: "M18.978 15.296v1.162c-.013-.148-.075-.36-.306-.408-.855-.179-2.406-.271-3.453.872-.205.223-.555.043-.519-.268 1.014-1.812 2.924-1.94 3.807-1.892.264.015.471.25.471.534Z"
  })));
};
export default Svg401;